import styled, { css } from 'styled-components';

const IconedButtonStyles = css`
  border-radius: 2px;
  border-width: 0px;
  height: 36px;
  padding: 5px 0px 5px 5px;
  display: flex;
  align-items: flex-start;
  justify-content: space-evenly;

  &:hover {
    border-width: 0px;
  }

  ${props => props.theme.isNotMobile && `
    line-height: 30px;
  `};

  ${props => !props.theme.isNotMobile && `
    margin-top: 8px;
  `};

  ${props => !props.theme.isNotMobile && `
    width: 100%;
  `};

  ${props => props.theme.isNotMobile && `
    width: 116px;
  `};

  & > span.icon-lw {
    border-radius: 2px;
  }

  & > span:not(.icon-lw) {
    flex-grow: 2;
    font-size: 12px;
    line-height: 26px;
    text-align: center;
  }
`;

const IconedButton = styled.button`
  ${IconedButtonStyles};
`;

export default IconedButton;
export { IconedButtonStyles };
